import React, { useEffect, useState } from 'react';
import { gradeColor } from './ScoreDial';
import { prefersReducedMotion } from '../../motion/tokens';
import './siteCheck.css';

const DEFAULT_FLOOR = Object.freeze({ score: 75, grade: 'B' });
const TOP_TEN = 91;
const clamp = (n) => Math.max(0, Math.min(100, Number(n) || 0));

// The F-to-A scale with three pins: you, the industry floor and the top 10%.
// The "You" pin slides in from the left once the scale is on screen.
export default function FloorScale({ score = 0, grade = 'F', floor = DEFAULT_FLOOR }) {
  const [youAt, setYouAt] = useState(() => (prefersReducedMotion() ? score : 0));

  useEffect(() => {
    if (prefersReducedMotion()) { setYouAt(score); return undefined; }
    let inner = null;
    const outer = requestAnimationFrame(() => { inner = requestAnimationFrame(() => setYouAt(score)); });
    return () => { cancelAnimationFrame(outer); if (inner !== null) cancelAnimationFrame(inner); };
  }, [score]);

  const floorScore = (floor && floor.score) || DEFAULT_FLOOR.score;
  return (
    <div className="relative mb-[52px] mt-[34px]">
      <div className="sc-scale-track" aria-hidden="true"><i /><i /><i /><i /><i /></div>
      <div className="sc-scale-letters mt-1.5 font-mono text-[11px] text-dim" aria-hidden="true">
        <span>F</span><span>D</span><span>C</span><span>B</span><span>A</span>
      </div>
      <span className="sc-pin" style={{ left: `${clamp(youAt)}%`, color: gradeColor(grade) }}>
        <b className="font-mono font-semibold">You {score}</b>
      </span>
      <span className="sc-pin sc-pin-below text-sky" style={{ left: `${clamp(floorScore)}%` }}>
        <b className="font-mono font-semibold">Floor {floorScore}</b>
      </span>
      <span className="sc-pin sc-pin-below text-[#3DD68C]" style={{ left: `${TOP_TEN}%` }}>
        <b className="font-mono font-semibold">Top 10%</b>
      </span>
    </div>
  );
}
